module.exports = __webpack_public_path__ + "img/verify3.87933b35.jpg";